import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import ApprovalWorkflowConfigurationLayer from '../components/ApprovalWorkflowConfigurationLayer';

const ApprovalWorkflowConfigurationPage = () => (
  <MasterLayout pageTitle='Approvals Setup'>
    <ApprovalWorkflowConfigurationLayer />
  </MasterLayout>
);

export default ApprovalWorkflowConfigurationPage;
